import { useTranslation } from 'react-i18next';

import { SelectMenu } from '@/components/molecules/SelectMenu';

import { SORT_OPTIONS, type SortBy } from './types';

import styles from './SortByDropdown.module.scss';

export interface SortByDropdownProps {
    value: SortBy;
    onChange: (next: SortBy) => void;
    className?: string;
    disabled?: boolean;
}

export default function SortByDropdown(props: SortByDropdownProps) {
    const { value, onChange, className, disabled = false } = props;
    const { t } = useTranslation();

    return (
        <div className={`${styles.sortByDropdown} ${className ?? ''}`}>
            <SelectMenu
                value={value}
                onChange={onChange}
                options={SORT_OPTIONS.map((option) => ({
                    value: option.value,
                    label: t(option.labelKey),
                }))}
                label={t('molecules.sortByDropdown.label')}
                disabled={disabled}
                width="wide"
                triggerClassName={styles.toggleButton}
            />
        </div>
    );
}
